import { FilterDef } from "./CommonTypes";

export const filters: FilterDef[] = [{
  displayName: {
    de: 'Helligkeit',
    en: 'Brightness'
  },
  defaultValue: 100,
  minValue: 0,
  maxValue: 200,
  step: 1,
  transform: (val: number) => `brightness(${val}%)`
}, {
  displayName: {
    de: 'Kontrast',
    en: 'Contrast'
  },
  defaultValue: 100,
  minValue: 0,
  maxValue: 200,
  step: 1,
  transform: (val: number) => `contrast(${val}%)`
}, {
  displayName: {
    de: 'Sättigung',
    en: 'Saturation'
  },
  defaultValue: 100,
  minValue: 0,
  maxValue: 200,
  step: 1,
  transform: (val: number) => `saturate(${val}%)`
}, {
  displayName: {
    de: 'Graustufen',
    en: 'Grayscale'
  },
  defaultValue: 0,
  minValue: 0,
  maxValue: 100,
  step: 1,
  transform: (val: number) => `grayscale(${val}%)`
}, {
  displayName: {
    de: 'Farbton',
    en: 'Hue'
  },
  defaultValue: 0,
  minValue: 0,
  maxValue: 360,
  step: 1,
  transform: (val: number) => `hue-rotate(${val}deg)`
}, {
  displayName: {
    de: 'Invertieren',
    en: 'Invert'
  },
  defaultValue: 0,
  minValue: 0,
  maxValue: 100,
  step: 1,
  transform: (val: number) => `invert(${val}%)`
}, {
  displayName: {
    de: 'Unschärfe',
    en: 'Blur'
  },
  defaultValue: 0,
  minValue: 0,
  maxValue: 10,
  step: 0.1,
  transform: (val: number) => `blur(${val}px)`
}];